import * as React from 'react';

type Props = {
    value:
        | {
              value: string;
              description: string;
          }
        | null
        | undefined;
};

export function Description(props: Props) {
    if (!props.value) {
        return null;
    }

    return <span>{props.value.value}</span>;
}
